import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Bell } from "lucide-react";

export const NotificationBell = ({ className = "" }) => {
  const navigate = useNavigate();
  const [data, setData] = useState({ items: [], unread: 0 });
  const load = () => api.get("/notifications").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, []);

  const openItem = async (n) => {
    if (!n.read) await api.post(`/notifications/${n.id}/read`);
    load(); navigate(n.link || "/products");
  };
  const readAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <Popover onOpenChange={(v) => v && load()}>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" data-testid="notification-bell" className={`relative ${className}`}>
          <Bell className="h-5 w-5" />
          {data.unread > 0 && (
            <span data-testid="notification-count" className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-destructive px-1 text-[10px] font-bold text-white">
              {data.unread > 99 ? "99+" : data.unread}
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0" data-testid="notification-panel">
        <div className="flex items-center justify-between border-b border-border px-3 py-2">
          <p className="font-heading text-sm font-bold">Alerts</p>
          {data.unread > 0 && <button data-testid="notification-read-all" onClick={readAll} className="text-xs font-medium text-primary hover:underline">Mark all read</button>}
        </div>
        <div className="max-h-96 overflow-y-auto">
          {data.items.length === 0 ? (
            <p className="px-3 py-6 text-center text-sm text-muted-foreground">No alerts</p>
          ) : data.items.map((n) => (
            <button key={n.id} data-testid={`notification-item-${n.id}`} onClick={() => openItem(n)}
              className={`block w-full border-b border-border px-3 py-2 text-left transition-colors hover:bg-muted/50 ${n.read ? "opacity-60" : "bg-primary/5"}`}>
              <p className="text-sm font-semibold">{n.title}</p>
              <p className="line-clamp-3 text-xs text-muted-foreground">{n.body}</p>
              <p className="mt-1 text-[10px] text-muted-foreground">{new Date(n.created_at).toLocaleString("en-IN")}</p>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
